export const download = (url: string, name: string) => {
  if (url.startsWith(window.location.origin)) {
    // same site
    const link = document.createElement('a')
    link.download = name
    link.href = url
    document.body.appendChild(link)
    link.click()
    setTimeout(() => {
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    }, 0)
  } else {
    // not same site (cross-domain request) - the "download" attribute does not work
    // https://stackoverflow.com/questions/66575118/download-attribute-for-a-does-not-work-for-pdfs-and-images
    fetch(url, { method: 'get', cache: 'no-cache' })
      .then((response) => response.blob())
      .then((blob) => {
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = name
        document.body.appendChild(link)
        link.click()
        setTimeout(() => {
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        }, 0)
      })
  }
}
